<template>
	<div class="leftres">
		<div>
			<div :class="showorhide ? 'inputtop' : 'inputtops'">
				<div v-for="(item, index) of formdata" :key="index" style="display: inline-block;">
					<Commondropdownlist ref="businessref" @provinceChage="provinceChage" :event="item.event"
						:options="item.options" :lablewith="item.lablewith" :inputdata="item.inputdata"
						:title="item.title" :fontSize="item.fontSize" :color="item.color"
						:placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype"
						:width="item.width"></Commondropdownlist>
				</div>
				<div :class="showorhide ? 'Btngroups' : 'Btngroup'">
					<CommonBtngroup :show="showorhide" @showclick="showclick" @hide="hide" @select="select"
						@reset="reset"></CommonBtngroup>
				</div>
				<div style="height:10px;"></div>
			</div>
			<div class="TableBox"
				style="box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1); margin-top: 10px; background-color: #FFFFFF;">
				<Businesshospitalrelationshiptable :tableData="tableData" :total="total" @CRExport="CRExport"
					@handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange">
				</Businesshospitalrelationshiptable>
			</div>
			<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibles" @cancel="cancel" @dialogOK="dialogOK"
				:src="'../assets/icon/icon-errors.png'">
				<span
					style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要重置选中账号的密码吗？</span>
			</Dialog>
		</div>
	</div>
</template>
<script>
	import Commondropdownlist from "../../../components/common-dropdownlist.vue";
	import CommonBtngroup from "../../../components/commongroup.vue";
	import Dialog from "../../../components/dialog.vue";
	import Businesshospitalrelationshiptable from "./components/businesshospitalrelationshiptable.vue";
	import utils from "../../../common/utils";
	import {
		CusRelationHospitalList,
		CusRelationHospitalExport,
		InventoryClassList,
		GetProvince,
		GetCity
	} from "@/api/home";
	export default {
		components: {
			Commondropdownlist,
			Businesshospitalrelationshiptable,
			Dialog,
			CommonBtngroup,
		},
		data() {
			return {
				tableData: [],
				total: 1,
				pageindex: 1,
				pageSize: 20,
				dialogVisibles: false,
				showorhide: true,
				formdata: [{
						inputdata: "",
						title: "产品线",
						fontSize: "14px",
						color: "#333333",
						placeholder: "全部",
						types: "",
						inputtype: "select",
						width: "220px",
						btx: true,
						lablewith: "80px",
						options: [],
					},
					{
						inputdata: "",
						title: "医院名称",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请输入",
						types: "text",
						inputtype: "input",
						width: "210px",
						lablewith: "80px",
					},
					{
						inputdata: "",
						title: "创建日期",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请输入",
						types: "",
						inputtype: "date",
						width: "140px",
						lablewith: '80px'
					},
					{
						inputdata: "",
						title: "经销商",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请输入",
						types: "text",
						inputtype: "input",
						width: "210px",
						lablewith: "80px",
					},
					{
						inputdata: "",
						title: "业务员",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请输入",
						types: "text",
						inputtype: "input",
						width: "220px",
						lablewith: "70px",
					},
					{
						inputdata: "",
						title: "医院省份",
						fontSize: "14px",
						color: "#333333",
						placeholder: "全部",
						types: "",
						inputtype: "selectMultiple",
						width: "210px",
						btx: true,
						lablewith: "85px",
						options: [],
						event: 'provinceChage'
					},
					{
						inputdata: "",
						title: "医院市",
						fontSize: "14px",
						color: "#333333",
						placeholder: "全部",
						types: "",
						inputtype: "select",
						width: "310px",
						btx: true,
						lablewith: "90px",
						options: [],
					},
				],
				from: {
					HPName: "",
					Customer: "",
					UserName: "",
					person: "",
					InvClass: "",
					ProvinceIDs: "",
					CityID: "",
					CreateTime1: "",
					CreateTime2: "",
				},
			};
		},
		mounted() {
			this.CusRelationHospitalList();
			this.inventoryClassList();
			this.getProvince()
		},
		methods: {
			// 列表
			async CusRelationHospitalList() {
				const loading = this.$loading({
					lock: true,
					text: "正在加载列表中...",
					spinner: "el-icon-loading",
					background: "rgba(255,255,255,0.3)",
				});
				let {
					data,
					code
				} = await CusRelationHospitalList({
					HPName: this.from.HPName,
					Customer: this.from.Customer,
					UserName: this.from.UserName,
					InvClass: this.from.InvClass,
					person: this.from.person,
					CreateTime1: this.from.CreateTime1,
					CreateTime2: this.from.CreateTime2,
					ProvinceIDs: this.from.ProvinceIDs,
					CityID: this.from.CityID,
					pageSize: this.pageSize,
					pageIndex: this.pageindex,
				});
				//console.log(code, data)
				if (code == 0) {
					this.total = data.Count;
					if (data.data) {
						this.tableData = data.data;
						loading.close();
					}
					loading.close();
				}
				loading.close();
			},
			// 导出
			async CusRelationHospitalExport() {
				let resexprot = await CusRelationHospitalExport({
					HPName: this.from.HPName,
					Customer: this.from.Customer,
					UserName: this.from.UserName,
					InvClass: this.from.InvClass,
					person: this.from.person,
					CreateTime1: this.from.CreateTime1,
					CreateTime2: this.from.CreateTime2,
					ProvinceIDs: this.from.ProvinceIDs,
					CityID: this.from.CityID,
					pageSize: this.pageSize,
					pageIndex: this.pageindex,
				});
				if (resexprot) {
					//console.log(resexprot);
					if (resexprot.code == 999) {
						this.$message({
							type: "warning",
							message: resexprot.message,
						});
					}
					utils.downloadFile(resexprot.data, "经销商医院业务员关系", "xlsx");
				} else {
					// 返回json
					this.$message.warning("导出失败");
				}
			},
			CRExport() {
				this.CusRelationHospitalExport();
			},
			// 产品线下拉
			async inventoryClassList() {
				let {
					code,
					data
				} = await InventoryClassList({});
				if (code == 0) {
					this.formdata[0].options = [];
					let obj2 = {
						key: "",
						value: "全部",
					};
					this.formdata[0].options.push(obj2);
					data.data.map((item, index) => {
						let obj = {
							key: item.InvClass,
							value: item.InvClassName,
						};
						this.formdata[0].options.push(obj);
					});
				}
			},

			//省份列表
			async getProvince() {
				let {
					data,
					code,
					message
				} = await GetProvince({})
				console.log(data, '省');
				if (code == 0) {
					this.formdata[5].options = []
					data.map((item, index) => {
						let obj = {
							key: item.Value,
							value: item.Text
						}
						this.formdata[5].options.push(obj)
					})

				} else {
					this.$message({
						type: 'error',
						message: "省份列表加载失败"
					})
				}
			},
			provinceChage(e) {
				if (e.modelvalue.length === 1) {
					this.getcity(e.modelvalue[0])
				}
			},
			// 市
			async getcity(provinceid) {
				this.$refs.businessref[6].modelvalue = ''
				let params = {
					ProvinceID: provinceid
				}
				let {
					code,
					data
				} = await GetCity({
					params
				})
				if (code == 0) {
					this.formdata[6].options = []
					data.map((item, index) => {
						let obj = {
							key: item.Value,
							value: item.Text
						}
						this.formdata[6].options.push(obj)
					})
				}
			},
			reset() {
				this.$refs.businessref.map((item, index) => {
					if (index == 2) {
						item.endTime = "";
						item.startTime = "";
					} else {
						item.modelvalue = "";
					}
				});
			},
			cancel() {
				// //console.log('name')
				this.dialogVisibles = false;
			},
			dialogOK() {
				// //console.log('name2')
				this.dialogVisibles = false;
			},
			hide() {
				this.showorhide = false;
				// //console.log("askdas", this.showorhide)
			},
			showclick() {
				this.showorhide = true;
			},
			select() {
				this.pageindex = 1;
				// 处理异常（折叠搜索框）
				try {
					this.from.HPName = this.$refs.businessref[1].modelvalue;
					this.from.Customer = this.$refs.businessref[3].modelvalue;
					this.from.InvClass = this.$refs.businessref[0].modelvalue;
					this.from.CreateTime1 = this.$refs.businessref[2].startTime;
					this.from.CreateTime2 = this.$refs.businessref[2].endTime;
					this.from.person = this.$refs.businessref[4].modelvalue;
					this.from.ProvinceIDs = this.$refs.businessref[5].modelvalue ? this.$refs.businessref[5].modelvalue
						.join(',') : '';
					this.from.CityID = this.$refs.businessref[6].modelvalue;
				} catch (error) {
					//console.log(error);
				}
				this.CusRelationHospitalList();
			},
			handleCurrentChange(pageindex) {
				this.pageindex = pageindex;
				this.CusRelationHospitalList();
			},
			handleSizeChange(paegSzie) {
				this.pageSize = paegSzie;
				this.CusRelationHospitalList();
			},
		},
	};
</script>

<style lang="less" scoped>
	.inputtop {
		width: 980px;
		height: 50px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
		padding-top: 15px;
		padding-bottom: 70px;
		transition: all 0.3s;
		overflow: hidden;
	}

	.inputtops {
		width: 980px;
		height: 0px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
		padding-top: 9px;
		padding-bottom: 64px;
		overflow: hidden;
		position: relative;
		transition: all 0.3s;
	}

	.Btngroup {
		display: inline-block;
		float: right;
		margin-right: 20px;
		width: 300px;
		height: 50px;
		background-color: #ffffff;
		position: relative;
		bottom: 45px;
	}

	.Btngroups {
		display: inline-block;
		float: right;
		margin-top: 5px;
		margin-right: 10px;
	}
</style>